import {SalesInvoiceLineDto} from "../model/invoice/sales/SalesInvoiceLineDto";
import {TaxDto} from "../model/invoice/TaxDto";
import Big from "big.js";


export class InvoiceCalculationResult {
    lines: Map<SalesInvoiceLineDto, { totalExclVat: Big, vatValue: Big, total: Big }> = new Map()
    vatBreakdown: Map<string, Big> = new Map()
    totalExclVat = Big(0)
    vatTotal = Big(0)
    total = Big(0)


    public byLine = (line: SalesInvoiceLineDto) => {
        return this.lines.get(line)!!
    }
}

export const calculateLines = (taxes: TaxDto[], lines: Array<SalesInvoiceLineDto>) => {
    const result = new InvoiceCalculationResult();
    lines.forEach(line => {
        const priceBig = Big(line.price ?? 0);
        const qBig = Big(line.quantity ? line.quantity : 1);
        const discount = (line.discountPct ? 100 - line.discountPct : 100) / 100;
        const discountBig = Big(discount)

        const totalExclVat = priceBig.mul(qBig).mul(discountBig).round(2);
        const tax = taxes.find(it => it.code === line.taxCode)!!;
        const vatValue = totalExclVat.mul(Big(tax.taxAmount)).div(Big(100)).round(2);
        result.lines.set(line, {
            totalExclVat: totalExclVat,
            vatValue: vatValue,
            total: totalExclVat.add(vatValue)
        })

        let breakdownValue = result.vatBreakdown.get(line.taxCode);
        breakdownValue = breakdownValue ? breakdownValue : Big(0);
        result.vatBreakdown.set(line.taxCode, breakdownValue.add(vatValue));
    })

    const calculatedValues = Array.from(result.lines.values());
    result.totalExclVat = calculatedValues.map(it => it.totalExclVat).reduce((a, b) => a.plus(b), Big(0))
    result.vatTotal = calculatedValues.map(it => it.vatValue).reduce((a, b) => a.plus(b), Big(0))
    result.total = calculatedValues.map(it => it.total).reduce((a, b) => a.plus(b), Big(0))


    return result;
}